import React, { useState } from 'react';
import Content from '../components/Content';
import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import MouseIcon from '@mui/icons-material/Mouse';
import Assessment from '@mui/icons-material/Assessment';
import { useNavigate } from 'react-router';
import generateCsv from '../services/reports';

const Reports = ({ userStore }) => {
  const [usersListLoading, setUsersListLoading] = useState(false);
  const [amazonClicksLoading, setAmazonClicksLoading] = useState(false);
  const [listSessionLoading, setListSessionLoading] = useState(false);
  const [mainBooksLoading, setMainBooksLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <Content title='Relatórios' userStore={userStore}>
      <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
        <List>
          <ListItemButton key='usersList' onClick={async () => {
            setUsersListLoading(true);
            generateCsv(
              `${process.env.REACT_APP_API_URL}reports/users`,
              userStore.token,
              null,
              () => setUsersListLoading(false),
              () => setUsersListLoading(false)
            );
          }}>
            <ListItemIcon>
              {usersListLoading ? <CircularProgress size={20} /> : <PeopleAltIcon />}
            </ListItemIcon>
            <ListItemText primary='Lista de usuários' />
          </ListItemButton>
          <Divider />
          <ListItemButton key='amazonClicks' onClick={async () => {
            setAmazonClicksLoading(true);
            generateCsv(
              `${process.env.REACT_APP_API_URL}reports/buy-book-tracking`,
              userStore.token,
              null,
              () => setAmazonClicksLoading(false),
              () => setAmazonClicksLoading(false)
            );
          }}>
            <ListItemIcon>
              {amazonClicksLoading ? <CircularProgress size={20} /> : <MouseIcon />}
            </ListItemIcon>
            <ListItemText primary='Cliques Amazon' />
          </ListItemButton>
          <Divider />
          <ListItemButton key='listSession' onClick={() => navigate(`/app/reports/sessions`)}>
            <ListItemIcon>
              {listSessionLoading ? <CircularProgress size={20} /> : <Assessment />}
            </ListItemIcon>
            <ListItemText primary='Relatório de sessões' />
          </ListItemButton>
          <Divider />
          <ListItemButton key='listExcerpt' onClick={() => navigate(`/app/reports/quotes`)}>
            <ListItemIcon>
              <Assessment />
            </ListItemIcon>
            <ListItemText primary='Relatório de trechos' />
          </ListItemButton>
          <Divider />
          <ListItemButton key='mainBooks' onClick={async () => {
            setMainBooksLoading(true);
            generateCsv(
              `${process.env.REACT_APP_API_URL}reports/main-books`,
              userStore.token,
              null,
              () => setMainBooksLoading(false),
              () => setMainBooksLoading(false)
            );
          }}>
            <ListItemIcon>
              {mainBooksLoading ? <CircularProgress size={20} /> : <Assessment />}
            </ListItemIcon>
            <ListItemText primary='Livros-Pai' />
          </ListItemButton>
        </List>
      </Box>
    </Content>
  );
};
export default Reports;
